import TemplateSurveyState from 'containers/SurveyPage/TemplateSurveyState';
import { find, get } from 'lodash';
import {
  getConceptIds,
  getAttributeIds,
} from 'containers/QuestionnairePage/QuestionGroup/utils';
import { PREDEFINED_LIKELIHOOD } from 'data/abTestQuestions';
import {
  mapQuestionsAndGroupsAsNodes,
  duplicateQuestion as duplicateQuestionHelper,
} from 'containers/QuestionnairePage/utils';
import { SURVEY_TYPE_PEEQ } from 'containers/Survey/constants';
import { AB_TEST_TYPES } from '../constants';

const productConceptTestingGenerator = ({
  template,
  variables,
  surveyType,
}) => {
  // pass the fetchedXXXX options only
  // if you intend to use the relevant template as-is

  const Survey = new TemplateSurveyState({
    // fetchedQuestionnaire: template.questionnaireTemplate,
    fetchedTargeting:
      surveyType === SURVEY_TYPE_PEEQ
        ? template.peeqTargetingTemplate
        : template.regularTargetingTemplate,
  });

  // extract and prepare user variables
  const abTestType = get(
    find(variables, ['name', 'ab_test_type']),
    'value',
    AB_TEST_TYPES.MONADIC,
  );
  const includeLikelihood = get(
    find(variables, ['name', 'include_likelihood']),
    'value',
    false,
  );
  const concepts = get(find(variables, ['name', 'concepts']), 'value', []).map(
    (concept) => ({ ...concept, text: `<div>${concept.text}</div>` }),
  );
  const repetitions =
    abTestType === AB_TEST_TYPES.MONADIC ? 1 : concepts.length;

  const { nodes: productConceptTestingTemplateQuestions } =
    mapQuestionsAndGroupsAsNodes(template.questionnaireTemplate);

  const ABTestGroupQuestion = duplicateQuestionHelper(
    productConceptTestingTemplateQuestions[0],
  );

  // CLEAN UP
  // remove likelihood questions
  const likeliHoodQuestions = ABTestGroupQuestion.questions.slice(-2);
  Survey.questionnaire.addQuestion(ABTestGroupQuestion);
  likeliHoodQuestions.forEach((likelihoodQuestion) => {
    Survey.questionnaire.removeQuestion({
      refId: likelihoodQuestion.refId,
      groupRefId: likelihoodQuestion.groupRefId,
    });
  });

  // Remove Concepts and Attributes
  const abTestConceptIds = getConceptIds(ABTestGroupQuestion);
  const attributesIds = getAttributeIds(ABTestGroupQuestion);

  abTestConceptIds.forEach((conceptId) => {
    Survey.questionnaire.removeAbConcept({
      refId: ABTestGroupQuestion.refId,
      conceptRefId: conceptId,
    });
  });
  attributesIds.forEach((attributeId) => {
    Survey.questionnaire.removeGroupAttribute({
      refId: ABTestGroupQuestion.refId,
      attributeRefId: attributeId,
      groupType: ABTestGroupQuestion.type,
    });
  });

  // SET UP
  // add user concepts
  concepts.forEach((concept) => {
    const conceptRefId = Survey.questionnaire.addAbConcept(
      ABTestGroupQuestion.refId,
    );
    if (conceptRefId) {
      Survey.questionnaire.updateAbConcept({
        refId: ABTestGroupQuestion.refId,
        conceptRefId,
        name: concept.name,
      });
    }
  });

  // add attribute and attribute values
  const abAttribute = Survey.questionnaire.addGroupAttribute({
    refId: ABTestGroupQuestion.refId,
    name: '',
    type: '',
    groupType: ABTestGroupQuestion.type,
  });

  concepts.forEach((concept, conceptIndex) => {
    const attributeValue = abAttribute.values[conceptIndex];

    Survey.questionnaire.updateGroupAttributeValue({
      refId: ABTestGroupQuestion.refId,
      attributeRefId: abAttribute.refId,
      attributeValueRefId: attributeValue.refId,
      text: concept.text,
      media: concept.media,
    });
  });

  // set AB type (monadic/sequential)
  Survey.questionnaire.updateAbProperties({
    refId: ABTestGroupQuestion.refId,
    properties: { repetitions },
  });

  // include likelihood questions based on user selection
  if (includeLikelihood) {
    Survey.questionnaire.addAbDefaultNodes({
      refId: ABTestGroupQuestion.refId,
      type: PREDEFINED_LIKELIHOOD,
    });
  }

  return { state: Survey.state };
};

export default productConceptTestingGenerator;
